<template functional v-slot:[`label`]>
    <v-row>
        <v-col cols="12" :sm="props.nameCols">
            <span class="font-weight-medium">{{ props.name }}</span>
        </v-col>
        <v-col cols="12" :sm="props.valueCols">
            {{ props.value }}
        </v-col>
    </v-row>
</template>
<script>
export default {
    functional: true,
    props: {
        name: String,
        value: [String, Number, Boolean],
        nameCols: {
            type: [String, Number],
            required: false,
            default: 2,
        },
        valueCols: {
            type: [String, Number],
            required: false,
            default: 10,
        },
    },
}
</script>
